import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Applicants } from '../applicants/Applicants';
import { AllApplicantsService } from '../applicants/applicants.service';
import { Router } from '@angular/router';
import { AcademicYear } from '../applicants/AcademicYear';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

@Component({
  selector: 'app-student-id',
  templateUrl: './student-id.component.html',
  styleUrls: ['./student-id.component.scss']
})
export class StudentIdComponent implements OnInit {

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

  constructor(
    private router: Router,
    private breakpointObserver: BreakpointObserver,
    private allApplicantsService: AllApplicantsService,
  ) { }

  ngOnInit(): void {
  }

}
